import { Container } from "react-bootstrap";
import { RouteProps } from "react-router";
import Content from "Types/Content";

import baIMG from "./assets/imgs/Upper-section/soundBA.png";
import proPic from "./assets/imgs/Upper-section/profileIMG.png";
import jsIcon from "./assets/imgs/icons-technology/jsIcon.png";
import stIcon from "./assets/imgs/icons-technology/style.png";
import htmlIcon from "./assets/imgs/icons-technology/htmlIcon.png";
import raIcon from "./assets/imgs/icons-technology/reactIcon.png";
import acIcon from "./assets/imgs/icons-about-me/activity.png";
import reIcon from "./assets/imgs/icons-about-me/map-pin.png";
import maIcon from "./assets/imgs/icons-about-me/refresh.png";
import boIcon from "./assets/imgs/icons-hobbies/bookIcon.png";
import muIcon from "./assets/imgs/icons-hobbies/musicIcon.png";
import yoIcon from "./assets/imgs/icons-hobbies/yogaIcon.png";

const IgnacioMustafha: React.FC<RouteProps> = () => {
  return (
    <div>
      <div className='row mb-5'>
        <img
          className='img-fluid w-100'
          src={baIMG}
          alt=''
          style={{ height: 400 }}
        />
      </div>

      <div className='container-fluid bg-white'>
        <div className='row mb-3 ml-3 justify-content-center align-items-stretch'>
          <div
            className='col-md-12 col-lg-4 d-flex flex-column mt-3'
            style={{ minHeight: 200 }}>
            <div className='card mb-2 border-dark'>
              <h4 className='card-header text-center bg-dark text-white'>
                Hobbies{" "}
              </h4>
            </div>

            <div className='card-body bg-secondary rounded text-center text-white p-5 flex-columnflex-fill '>
              <div className='d-flex justify-content-center'>
                <div>
                  <img src={muIcon} alt='' />
                </div>
                <div>
                  <p className='text-light'>Escuchar música</p>
                </div>
              </div>
              <div className='d-flex justify-content-center'>
                <div>
                  <img src={boIcon} alt='' />
                </div>
                <div>
                  <p className='text-light'>Leer</p>
                </div>
              </div>

              <div className='d-flex justify-content-center'>
                <div>
                  <img src={yoIcon} alt='' />
                </div>
                <div>
                  <p className='text-light'>Hacer Yoga</p>
                </div>
              </div>
            </div>
          </div>

          <div
            className='col-md-12 col-lg-4 d-flex flex-column mt-3'
            style={{ minHeight: 200 }}>
            <div className='card mb-2 border-dark'>
              <h4 className='card-header text-center bg-dark text-white'>
                Sobre mi
              </h4>
            </div>

            <div className='card-body bg-secondary rounded text-white p-4 d-flex flex-column'>
              <div className='d-flex justify-content-center'>
                <div>
                  <img src={acIcon} alt='' />
                </div>
                <div>
                  <p className='text-light'>
                    Nací en la ciudad de Santa Fe, tengo 26 años y soy
                    estudiante de la Lic. en música.
                  </p>
                </div>
              </div>

              <div className='d-flex justify-content-center'>
                <div>
                  <img src={maIcon} alt='' />
                </div>
                <div>
                  <p className='text-light'>
                    Me apasiona aprender sobre nuevas tecnologías, idomas y
                    diferentes culturas.
                  </p>
                </div>
              </div>

              <div className='d-flex justify-content-center'>
                <div>
                  <img src={reIcon} alt='' />
                </div>
                <div>
                  <p className='text-light'>Siempre sigo mi intución.</p>
                </div>
              </div>
            </div>
          </div>

          <div
            className='col-md-12 col-lg-4 d-flex flex-column mt-3'
            style={{ minHeight: 200 }}>
            <div className='card mb-2 border-dark'>
              <h4 className='card-header text-center bg-dark text-white'>
                Tecnologías
              </h4>
            </div>

            <div className='card-body bg-secondary rounded d-flex align-items-center text-white flex-fill '>
              <div className='d-flex flex-column align-items-end'>
                <img className='w-50' src={jsIcon} alt='' />
                <img className='w-50' src={htmlIcon} alt='' />
              </div>
              <div className='d-flex flex-column  justify-content-center'>
                <img className='w-50' src={stIcon} alt='' />
                <img className='w-50' src={raIcon} alt='' />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default new Content({
  Component: IgnacioMustafha,
  title: "Ignacio Mustafha",
  route: "ignacio-mustafha",
  tags: ["junior"]
});
